import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
//codex-- Toolbar links live in WipSchedulerActionBar; this page retains API-error navigation.
import { useNavigate } from 'react-router-dom';
import HeadingCp from '../components/HeadingCp';
import WipSchedulerDetailsModal from '../components/WipSchedulerDetailsModal';
import WipFormModal from '../components/WipFormModal';
//codex-- Group WIP actions and calendar controls in the shared toolbar style.
import WipSchedulerActionBar from '../components/WipSchedulerActionBar';
import { formatTimeTo12HourUtil } from '../utils/formatTimeTo12HourUtil';
import DayViewTimelineWip from '../components/DayViewTimelineWip';
import { add, parseISO, set } from 'date-fns';
import { is, se } from 'date-fns/locale';
import LegendCP from '../components/LegendCP';

const WipSchedulerPage = () => {
  const [Jobs, setJobs] = useState([]);
  const [viewMode, setViewMode] = useState('week'); // 'day', 'week', 'month'
  const [loading, setLoading] = useState(false);

  // Confirm Delete Modal states
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedInspection, setSelectedInspection] = useState(null);
  const [formData, setFormData] = useState({
    id: '',
    job_number: '',
    tech_id: '',
    schedule_from: '',
    schedule_to: '',
    additional_tech_id: '',
    tentative: false,
    status_description: '',
  });
  const [isEditing, setIsEditing] = useState(false);
  const [technicians, setTechnicians] = useState([]);

  // For Month/Week
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedDates, setSelectedDates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // For Day View
  const [selectedDay, setSelectedDay] = useState(new Date()); // default to "today done"

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [disabled, setDisabled] = useState(false);

  // ---------------- Date Helpers ----------------
  const getWeekStart = (date = new Date()) => {
      const dayOfWeek = date.getDay() || 7;
      const diff = date.getDate() - dayOfWeek + 1;
    return new Date(date.getFullYear(), date.getMonth(), diff);
  };

  const getWeekDates = (startOfWeek) => {
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const currentDay = new Date(
        startOfWeek.getFullYear(),
        startOfWeek.getMonth(),
        startOfWeek.getDate() + i
      );
      dates.push(currentDay);
    }
    return dates;
  };

  const getMonthDates = (year, month) => {
    const date = new Date(year, month - 1, 1);
    const dates = [];
    while (date.getMonth() + 1 === month) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  };

 /* ---------- new: department filter ---------- */
 const [employees, setEmployees] = useState([]);
 const [selectedDept, setSelectedDept] = useState('Install'); // Default to 'Install' department
  
 /* a memo-ised list of departments for the dropdown */
 const departmentOptions = React.useMemo(() => {
   const depts = new Set(employees.map(e => e.department).filter(Boolean));
   return ['All', ...depts];
 }, [employees]);  

  // ---------------- useEffect: Update Calendar Range ----------------
  useEffect(() => {
    if (viewMode === 'week') {
      const today = new Date();
      const weekStart = getWeekStart(today);
      const weekDates = getWeekDates(weekStart);
      setSelectedDates(weekDates);
      setStartDate(weekDates[0]);
      setEndDate(weekDates[6]);
    } else if (viewMode === 'month') {
      const monthDates = getMonthDates(selectedYear, selectedMonth);
      setSelectedDates(monthDates);
      setStartDate(monthDates[0]);
      setEndDate(monthDates[monthDates.length - 1]);
    }
    // If Day View, we rely on selectedDay in a separate effect
    fetchTechnicians();
  }, [viewMode, selectedMonth, selectedYear, isModalOpen, isDetailModalOpen]);

  // For week/month, fetch once startDate/endDate are set
  useEffect(() => {
    if ((viewMode === 'week' || viewMode === 'month') && startDate && endDate) {
      fetchWipSchedule(startDate, endDate);
    }
  }, [viewMode, startDate, endDate]);

  // For Day View, fetch data for just that day
  useEffect(() => {
    if (viewMode === 'day') {
      const dayStart = new Date(selectedDay);
      dayStart.setHours(0, 0, 0, 0);

      const dayEnd = new Date(selectedDay);
      dayEnd.setHours(23, 59, 59, 999);

      fetchWipSchedule(dayStart, dayEnd);
    }
  }, [viewMode, selectedDay]);

   // ---------------- API Calls ----------------
  const fetchWipSchedule = async (startD, endD) => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/wip_crud.php`, {
        params: {
          month: 'all',
          getWipScheduleList: 1,
          startDate: startD.toISOString().split('T')[0],
          endDate: endD.toISOString().split('T')[0],
        },
      });
      const data = Array.isArray(response.data[0]) ? response.data[0] : [];
      setJobs(data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTechnicians = async () => {
    try {
      const response = await axios.get(`${apiUrl}/contracts_crud.php`, {
        // , full_list: false 
        params: { employee_list: 'true'},
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      });
      const employeesData = Array.isArray(response.data) ? response.data : [];      
      setEmployees(employeesData);
      if (employeesData.length === 0) {
        toast.error('No employees found!', { position: 'top-center' });
      }
   /* ----------------------------------------------------------
    SORT technicians:
    1) by department  (A->Z)
    2) inside each department by last name  (A->Z)
    ---------------------------------------------------------- */
   const sorted = [...employeesData].sort((a, b) => {
   const depA = (a.department  || '').toLowerCase();
   const depB = (b.department  || '').toLowerCase();
   if (depA !== depB) return depA.localeCompare(depB);
   const lastA = (a.last_name   || '').toLowerCase();
   const lastB = (b.last_name   || '').toLowerCase();
    return lastA.localeCompare(lastB);
  });
  setTechnicians(sorted);                 
      // setTechnicians(employeesData);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleApiError = (error) => {
    if (error.response && error.response.status === 401) {
      toast.error('Session expired. Please login again.', {
        position: 'top-center',
      });
      navigate('/login');
    } else if (error.response && error.response.status === 403) {
      toast.error('Access denied.', {
        position: 'top-center',
      });
    } else {
      toast.error('An error occurred while fetching data.', {
        position: 'top-center',
      });
    }
  };

   // ---------------- Navigation / Handlers ----------------
  const handleMonthChange = (e) => {
    const [year, month] = e.target.value.split('-');
    setSelectedYear(parseInt(year, 10));
    setSelectedMonth(parseInt(month, 10));
  };

  const handlePreviousWeek = () => {
    const prevWeekStart = new Date(selectedDates[0]);
    prevWeekStart.setDate(prevWeekStart.getDate() - 7);
    const weekDates = getWeekDates(prevWeekStart);
    setSelectedDates(weekDates);
    setStartDate(weekDates[0]);
    setEndDate(weekDates[6]);
  };

  const handleNextWeek = () => {
    const nextWeekStart = new Date(selectedDates[0]);
    nextWeekStart.setDate(nextWeekStart.getDate() + 7);
    const weekDates = getWeekDates(nextWeekStart);
    setSelectedDates(weekDates);
    setStartDate(weekDates[0]);
    setEndDate(weekDates[6]);
  };

  //done
  const handleViewChange = (e) => {
    if (e.target.value === 'day') {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    setViewMode(e.target.value);
  };

  //done
  const openModal = (isEdit = false) => {
    setIsModalOpen(true);
    setIsEditing(isEdit);
    // Clear form if new
    if (!isEdit) {
      setFormData({
        schedule_id: '',
        job_number: '',
        tech_id: '',
        schedule_from: '',
        schedule_to: '',
        date: '',
        status: '',
        additional_tech_id: '',
        tentative: false,
        status_description: '',
      });
    }
  };

  //done
  const closeModal = () => {
    setIsModalOpen(false);
  };

   // ---------------- Form Submit ----------------
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(formData.end_time < formData.start_time){
      toast.error('Schedule time out must be later than schedule time in.', {
        position: 'top-center',
      });
      setLoading(false);
      return;
    }

    if(parseInt(formData.tech_id) === parseInt(formData.additional_tech_id)) { 
      toast.error('You cannot use the same technician as lead and additional.', {
        position: 'top-center',
      });
      setLoading(false);
      return;
    }

    // inside onSubmit before sending:
    if (formData.tentative && !formData.status_description?.trim()) {
      toast.error('Please provide a Status Description for tentative schedules.', { position: 'top-center' });
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/wip_crud.php`, {
        data: formData,
          status: 'recordJob',
          isEdit: isEditing
      });
      if (response.data.success) {
        toast.success('wip scheduled successfully!');
        setFormData({
          id: '',
          job_number: '',
          schedule_from: '',
          schedule_to: '',
          date: '',
          status: '',
          tech_id: '',
          start_time: '',
          end_time: '',
          user_comment: '',
          billable: '',
          invoiced:'',
          additional_tech_id: '',
          tentative: false,
          status_description: '',
          // whatever else you need to clear…
        });
        closeModal();
        reFetchCurrentView();
      } else {
        toast.error(response.data.error || 'Failed to save inspection.');
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  // ---------------- Delete with Confirm ----------------
  const handleDeleteRequest = () => {
    setDeleteId(formData?.schedule_id);
    setShowConfirmModal(true);
    setIsModalOpen(false);
  };

  // 2. User confirms => call delete
  const confirmDelete = async () => {
    setShowConfirmModal(false);
    try {
      const response = await axios.post(`${apiUrl}/wip_crud.php`, {
        data: { schedule_id: deleteId },
        status: 'deleteSchedule',
      });
      if (response.data[0] === 'success') {
        toast.success('Inspection successfully deleted!');
        closeModal();
        reFetchCurrentView();
      } else {
        toast.error(response.data.error || 'Failed to delete inspection.');
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  // 3. User cancels => just hide the confirm modal
  const cancelDelete = () => {
    setShowConfirmModal(false);
  };

  // Utility to re-fetch data based on current view mode
  const reFetchCurrentView = () => {
    if (viewMode === 'day') {
      const dayStart = new Date(selectedDay);
      dayStart.setHours(0, 0, 0, 0);
      const dayEnd = new Date(selectedDay);
      dayEnd.setHours(23, 59, 59, 999);
      fetchWipSchedule(dayStart, dayEnd);
    } else if (viewMode === 'week' || viewMode === 'month') {
      if (startDate && endDate) {
        fetchWipSchedule(startDate, endDate);
      }
    }
  };

  // ---------------- Click Handlers ----------------
  const handleEventClick = (inspection) => {
    setSelectedInspection(inspection);
    setIsDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
  };

  const handleEditInspection = () => {
    const editableInspection = {
      ...selectedInspection,
      id: selectedInspection.schedule_id, // rename for the form
      tentative: selectedInspection.status === 'tentative' ? true : false
    };
    setFormData(editableInspection);
    setIsDetailModalOpen(false);
    setIsModalOpen(true);
    setIsEditing(true);
  };

  // For week/month: cell click => new inspection
  const handleCellClick = (date, technician) => {
    openModal(false);
    setFormData((prevData) => ({
      ...prevData,
      // job_site: FormData.job_site || '',
      schedule_from: date.toISOString().split('T')[0],
      schedule_to: date.toISOString().split('T')[0],
      tech_id: technician?.id || '',
    }));
  };

  // For day view, user picks a day from a date input - done
  const handleDayChange = (e) => {
    const [year, month, day] = e.target.value.split('-').map(Number);
    const newDay = new Date(year, month - 1, day, 12, 0, 0); // local date at noon
    setSelectedDay(newDay);
  };

  // Department filter logic - place just before the return
  const filteredTechnicians = selectedDept && selectedDept !== "All"
  ? technicians.filter(t => t.department === selectedDept)
  : technicians;

  // parseLocalDate helper
  const parseLocalDate = (dateString) => {
    // if (!dateString) return null;
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day, 0, 0, 0);
  };
  
  // ---------------- Render ----------------
  return (
    //codex-- Let the toolbar fit smaller screens; calendar grids keep their own horizontal scrolling.
    <div className="mx-auto w-[90vw] min-w-0 py-10 sm:px-6 lg:px-8">
      <HeadingCp label="WIP Scheduler" />

      {/*codex-- Preserve existing view/date/new-schedule handlers and apply department drafts through the new toolbar. */}
      <WipSchedulerActionBar
        viewMode={viewMode}
        onViewChange={handleViewChange}
        selectedDept={selectedDept}
        departments={departmentOptions}
        onDepartmentChange={setSelectedDept}
        selectedDay={selectedDay}
        onDayChange={handleDayChange}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
        onMonthChange={handleMonthChange}
        selectedDates={selectedDates}
        onPreviousWeek={handlePreviousWeek}
        onNextWeek={handleNextWeek}
        onNewSchedule={() => openModal(false)}
        loading={loading}
      />

      {/* Day View */}
      {viewMode === 'day' && (() => {
        const dayISO = selectedDay.toISOString().split('T')[0];

        const daySchedule = Jobs.filter(insp => {
          const fromDate = parseLocalDate(insp.schedule_from);
          const toDate = parseLocalDate(insp.schedule_to || insp.schedule_from);
          if (!fromDate || !toDate) return false;
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
          return selectedDay >= fromDate && selectedDay <= toDate;
        });

        // const daySchedule = Jobs.filter( insp => (insp.schedule_from ?? '') === dayISO );

        
        const techJobsMap = {};
        filteredTechnicians.forEach(tech => {
          const techId = String(tech.id);
          techJobsMap[techId] = Jobs.filter(insp => {
            // Date range check (in case you allow multi-day jobs)
            const fromDate = insp.schedule_from;
            const toDate   = insp.schedule_to || insp.schedule_from;

            // Check if selectedDay is within range
            const inRange = dayISO >= fromDate && dayISO <= toDate;

            // Match if this tech is lead or additional
            return inRange &&
              (String(insp.tech_id) === techId ||
              (insp.additional_tech_id && String(insp.additional_tech_id) === techId));
          });
        });

        return (
          <DayViewTimelineWip
            selectedDay={selectedDay}
            Jobs={daySchedule}
            techJobsMap={techJobsMap} // <-- new!
            onEventClick={(insp) => {
              setSelectedInspection(insp);
              setIsDetailModalOpen(true);
            }}
            /* ② When user clicks an empty cell:
              child now sends { hour, minute, techId }          */
            onEmptyClick={({ hour, minute, techId }) => {
              openModal(false);                               // create-new
              const hh = String(hour).padStart(2,'0');
              const mm = String(minute).padStart(2,'0');
              const day = selectedDay.toISOString().split('T')[0];

              setFormData(prev => ({
                ...prev,
                schedule_from : day,
                schedule_to   : day,
                schedule_time_in   : `${hh}:${mm}:00`,
                schedule_time_out  : `${hh === '23' ? hh : String(hour+1).padStart(2,'0')}:00:00`,
                tech_id       : techId          // <-- NEW!
              }));
            }}
            /* pass list of techs so child can draw rows */
            technicians={filteredTechnicians}
          />
        );
      })()}

      {(viewMode === 'week' || viewMode === 'month') && (
        <WeekOrMonthView
          viewMode={viewMode}
          selectedDates={selectedDates}
          technicians={filteredTechnicians}
          Jobs={Jobs}
          handleEventClick={handleEventClick}
          handleCellClick={handleCellClick}
        />
      )}

      {/* ---------------- WIP Form Modal ---------------- */}
      <WipFormModal
        isOpen={isModalOpen}
        onClose={closeModal}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        technicians={technicians}
        handleDelete={handleDeleteRequest} 
        isEditing={isEditing}
        disabled={disabled}
        loading={loading}
      />

      {/* ---------------- Confirm Deletion Modal ---------------- */}
      {showConfirmModal && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen text-center">
            {/* Background overlay */}
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            {/* Modal panel */}
            <div
              className="inline-block bg-white rounded-lg text-left 
              overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Confirm Deletion
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Are you sure you want to delete this schedule? This action cannot be
                      undone.
                    </p>
                  </div>
                </div>
              </div>
              {/* Modal actions */}
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
                <button
                  onClick={confirmDelete}
                  className="w-full inline-flex justify-center rounded-md border border-transparent 
                  shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Delete
                </button>
                <button
                  onClick={cancelDelete}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 
                  shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- Wip Scheduler Details Modal ---------------- */}
      <WipSchedulerDetailsModal
        isOpen={isDetailModalOpen}
        onClose={closeDetailModal}
        inspection={selectedInspection}
        onEdit={handleEditInspection}
      />
    </div>
  );
};

// -------------------- WeekOrMonthView Component --------------------
const WeekOrMonthView = ({
  viewMode,
  selectedDates,
  technicians,
  Jobs,
  handleEventClick,
  handleCellClick,
}) => {
  // For each date/technician, find any inspection
  const getScheduledInspections = (date, technicianId) => {
    const parseLocalDate = (dateString) => {
      // if (!dateString) return null;
      const [year, month, day] = dateString.split('-').map(Number);
      return new Date(year, month - 1, day, 0, 0, 0);
    };

    const currentDate = new Date(date);
    currentDate.setHours(0, 0, 0, 0);

    return Jobs.filter((insp) => {
      const fromDate = parseLocalDate(insp.schedule_from);
      const toDate = parseLocalDate(insp.schedule_to || insp.schedule_from);

      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);

      const leadId = String(insp.tech_id);
      const addlId = String(insp.additional_tech_id || '');

      const techMatch = leadId === technicianId || addlId === technicianId;
      const dateInRange = currentDate >= fromDate && currentDate <= toDate;

      return techMatch && dateInRange;
    });
  };

  return (    
    <div className="overflow-auto">
      <div className="flex flex-wrap gap-2 mb-4">
        <LegendCP color="fill-orange-300" label="Tentative" />
        <LegendCP color="fill-blue-300" label="Pending" />
        <LegendCP color="fill-green-400" label="Completed" />
        <LegendCP color="fill-red-600" label="FDNY Inspections" />
        {/* <LegendCP color="fill-yellow-300" label="Assigned" /> */}
      </div>
      {/*codex-- Keep scheduler cells readable inside the calendar scroll area without widening the toolbar. */}
      <div className="grid min-w-[72rem]" style={{ gridTemplateColumns: `200px repeat(${selectedDates.length}, 1fr)` }} >
        {/* blank top-left corner */}
        <div className="bg-gray-100 sticky top-0 z-10" />

        {/* Date headers */}
        {selectedDates.map((date, idx) => (
          <div key={idx} className="bg-gray-100 text-center p-2 sticky top-0 z-10 border">
            {date.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric' })}
          </div>
        ))}

        {/* Technician rows */}
        {technicians.map((tech, rowIndex) => (
          <React.Fragment key={tech.id || rowIndex}>
            <div className="border p-2 bg-white sticky left-0 z-10">
              <div className="font-bold text-black">
                {tech.first_name} {tech.last_name}
                {tech.title && (
                <div className={`text-xs ${tech.title.toLowerCase().includes('helper') ? 'text-yellow-500' 
                                                                                        : tech.o_f_type === 'Field' 
                                                                                        ? 'text-blue-600' 
                                                                                        : 'text-gray-600'}`}>{tech.title}
                </div>
                )}                
                <div className="text-xs text-gray-700">{tech.department}</div>
              </div>
            </div>

            {selectedDates.map((date, colIndex) => {
              const techId = String(tech.id);
              const scheduledInspections = getScheduledInspections(date, techId);
              const isScheduled = scheduledInspections.length > 0;
              const isCompleted = isScheduled && scheduledInspections[0].status === 'Completed';              

              return (
                  <div
                    key={`${tech.id || rowIndex}-${colIndex}`}
                    className={`border h-16 cursor-pointer hover:bg-slate-100 ${
                      isScheduled
                        ? isCompleted
                          ? 'bg-green-300'
                          : scheduledInspections[0].status === 'tentative'
                            ? 'bg-orange-300 font-bold'
                            : scheduledInspections[0].user_comment?.toLowerCase().includes('@fdny') ||
                              scheduledInspections[0].user_comment?.toLowerCase().includes('@FDNY')
                              ? 'bg-red-500 text-white font-bold'
                              : 'bg-blue-200'
                        : 'bg-white'
                    }`}
                    onClick={() =>
                      isScheduled
                        ? handleEventClick(scheduledInspections[0])
                        : handleCellClick(date, tech)
                    }
                  >
                  {isScheduled && (
                    <div>
                      <p className="font-bold text-xs text-center">
                        {scheduledInspections[0].job_site || 'Unnamed'}
                      </p>
                      <p className="text-green-800 text-xs text-center">
                        {scheduledInspections[0].customer_name || 'customer missing'}
                      </p>
                      <p className="text-gray-600 text-xs text-center pl-1">
                        {scheduledInspections[0].start_time
                          ? formatTimeTo12HourUtil(scheduledInspections[0].start_time)
                          : 'no time'}
                        {scheduledInspections[0].end_time
                          ? ' - ' + formatTimeTo12HourUtil(scheduledInspections[0].end_time)
                          : ' - no time'}
                      </p>
                      <p className="text-gray-800 text-xs text-center ">
                        {scheduledInspections[0].job_number || 'No job number'}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default WipSchedulerPage;
